var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9133 12.596C9.04353 13.7858 7.09652 14.1412 5.0259 13.554C1.19369 12.4723 -0.92329 8.37744 0.390167 4.63795C1.71908 0.867551 5.98395 -1.01765 9.66163 0.558502C13.3239 2.1192 14.9309 6.50769 13.0612 10.0618C12.6749 10.788 12.7985 11.1434 13.3393 11.6534C14.6528 12.8895 15.9044 14.1876 17.1715 15.4547C17.8669 16.15 17.9441 16.8608 17.3878 17.4017C16.8625 17.9116 16.1517 17.8343 15.4872 17.1853C13.9729 15.671 12.474 14.1566 10.9133 12.596ZM6.98836 1.60927C4.05239 1.57836 1.65727 3.94259 1.62636 6.8631C1.59546 9.78361 3.95968 12.1942 6.88019 12.2405C9.78525 12.2869 12.2113 9.90723 12.2422 6.98672C12.2731 4.05075 9.90887 1.64017 6.98836 1.60927Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchHeader);
export default __webpack_public_path__ + "static/media/SearchHeader.5897b0759351d663e6df74cea8fec1b2.svg";
export { ForwardRef as ReactComponent };